import React, { useEffect, useState } from "react";
import "./ListProduct.css";
import cross_icon from "../Assets/cross_icon.png";
import edit_icon from "../Assets/edit_icon.png";
import upload_area from "../Assets/upload_area.svg";
import { backend_url, auth_url, currency } from "../../App";

const ListProduct = () => {
  const [allproducts, setAllProducts] = useState([]);
  const [editingProduct, setEditingProduct] = useState(null);
  const [editFormData, setEditFormData] = useState({
    name: "",
    description: "",
    category: "",
    productType: "",
    old_price: "",
    new_price: "",
    waist: "",
    thighs: "",
    length: "",
    stock_bal: "",
    // Size parameters for all sizes
    sizeSCheckbox: false,
    sizeSCH: "0",
    sizeSSH: "0",
    sizeSLE: "0",
    sizeSSL: "0",
    stock_balS: "0",
    sizeMCheckbox: false,
    sizeMCH: "0",
    sizeMSH: "0",
    sizeMLE: "0",
    sizeMSL: "0",
    stock_balM: "0",
    sizeLCheckbox: false,
    sizeLCH: "0",
    sizeLSH: "0",
    sizeLLE: "0",
    sizeLSL: "0",
    stock_balL: "0",
    sizeXLCheckbox: false,
    sizeXLCH: "0",
    sizeXLSH: "0",
    sizeXLLE: "0",
    sizeXLSL: "0",
    stock_balXL: "0",
    sizeXXLCheckbox: false,
    sizeXXLCH: "0",
    sizeXXLSH: "0",
    sizeXXLLE: "0",
    sizeXXLSL: "0",
    stock_balXXL: "0",
  });
  const [editImages, setEditImages] = useState({
    image_main: null,
    image_back: null,
    image_side: null,
  });

  const fetchInfo = async () => {
    try {
      console.log("Fetching updated product list...");
      const response = await fetch(`${backend_url}/admin/allproducts`, {
        headers: {
          "auth-token": localStorage.getItem("auth-token"),
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Fetched products:", data);
      setAllProducts(data);
    } catch (error) {
      console.error("Error fetching products:", error);
      alert("Failed to load products. Please try again later.");
    }
  };

  useEffect(() => {
    fetchInfo();
  }, []);

  const removeProduct = async (id) => {
    try {
      const response = await fetch(`${backend_url}/admin/removeproduct`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id }),
      });
      const data = await response.json();
      if (data.success) {
        alert(`Product "${data.name}" successfully deleted.`);
        setAllProducts(allproducts.filter((item) => item.id !== id));
      } else {
        alert(
          data.message || "Failed to remove product. Please try again later."
        );
      }
    } catch (error) {
      alert("Failed to remove product. Please try again later.");
    }
  };

  const updateProduct = async (id) => {
    try {
      const response = await fetch(`${backend_url}/admin/updateproduct`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "auth-token": localStorage.getItem("auth-token"),
        },
        body: JSON.stringify({ id }),
      });
      const data = await response.json();
      console.log("Update response:", data);
      if (data.success) {
        alert("Product updated successfully");
        fetchInfo();
      } else {
        alert(data.message || "Error updating product");
      }
    } catch (error) {
      console.error("Error updating product:", error);
      alert("Error updating product");
    }
  };

  const handleEdit = (product) => {
    setEditingProduct(product);
    setEditFormData({
      name: product.name,
      description: product.description,
      category: product.category,
      productType: product.productType || "",
      old_price: product.old_price,
      new_price: product.new_price,
      waist: product.waist || "",
      thighs: product.thighs || "",
      length: product.length || "",
      stock_bal: product.stock_bal || "",
      // Size parameters for all sizes
      sizeSCheckbox: product.sizeSCheckbox || false,
      sizeSCH: product.sizeSCH || "0",
      sizeSSH: product.sizeSSH || "0",
      sizeSLE: product.sizeSLE || "0",
      sizeSSL: product.sizeSSL || "0",
      stock_balS: product.stock_balS || "0",
      sizeMCheckbox: product.sizeMCheckbox || false,
      sizeMCH: product.sizeMCH || "0",
      sizeMSH: product.sizeMSH || "0",
      sizeMLE: product.sizeMLE || "0",
      sizeMSL: product.sizeMSL || "0",
      stock_balM: product.stock_balM || "0",
      sizeLCheckbox: product.sizeLCheckbox || false,
      sizeLCH: product.sizeLCH || "0",
      sizeLSH: product.sizeLSH || "0",
      sizeLLE: product.sizeLLE || "0",
      sizeLSL: product.sizeLSL || "0",
      stock_balL: product.stock_balL || "0",
      sizeXLCheckbox: product.sizeXLCheckbox || false,
      sizeXLCH: product.sizeXLCH || "0",
      sizeXLSH: product.sizeXLSH || "0",
      sizeXLLE: product.sizeXLLE || "0",
      sizeXLSL: product.sizeXLSL || "0",
      stock_balXL: product.stock_balXL || "0",
      sizeXXLCheckbox: product.sizeXXLCheckbox || false,
      sizeXXLCH: product.sizeXXLCH || "0",
      sizeXXLSH: product.sizeXXLSH || "0",
      sizeXXLLE: product.sizeXXLLE || "0",
      sizeXXLSL: product.sizeXXLSL || "0",
      stock_balXXL: product.stock_balXXL || "0",
    });
    setEditImages({
      image_main: null,
      image_back: null,
      image_side: null,
    });
  };

  const handleEditFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    setEditFormData((prev) => {
      const updated = {
        ...prev,
        [name]: newValue,
      };

      // Remove auto-calculation logic - allow manual editing of stock balance
      // Stock balance should be editable for all product types

      return updated;
    });
  };

  const handleEditImageChange = (e, imageType) => {
    const file = e.target.files[0];
    if (file) {
      setEditImages((prev) => ({
        ...prev,
        [imageType]: file,
      }));
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    console.log("Starting edit submit process...");

    try {
      const formData = new FormData();

      formData.append("id", editingProduct.id);
      // Note: Product name is immutable and cannot be changed
      // formData.append("name", editFormData.name);
      formData.append("description", editFormData.description);
      formData.append("category", editFormData.category);
      formData.append("productType", editFormData.productType);
      formData.append("waist", editFormData.waist);
      formData.append("thighs", editFormData.thighs);
      formData.append("length", editFormData.length);
      formData.append("stock_bal", editFormData.stock_bal);
      formData.append("old_price", editFormData.old_price);
      formData.append("new_price", editFormData.new_price);

      // Add size parameters for all sizes
      formData.append("sizeSCheckbox", editFormData.sizeSCheckbox);
      formData.append("sizeSCH", editFormData.sizeSCH);
      formData.append("sizeSSH", editFormData.sizeSSH);
      formData.append("sizeSLE", editFormData.sizeSLE);
      formData.append("sizeSSL", editFormData.sizeSSL);
      formData.append("stock_balS", editFormData.stock_balS);

      formData.append("sizeMCheckbox", editFormData.sizeMCheckbox);
      formData.append("sizeMCH", editFormData.sizeMCH);
      formData.append("sizeMSH", editFormData.sizeMSH);
      formData.append("sizeMLE", editFormData.sizeMLE);
      formData.append("sizeMSL", editFormData.sizeMSL);
      formData.append("stock_balM", editFormData.stock_balM);

      formData.append("sizeLCheckbox", editFormData.sizeLCheckbox);
      formData.append("sizeLCH", editFormData.sizeLCH);
      formData.append("sizeLSH", editFormData.sizeLSH);
      formData.append("sizeLLE", editFormData.sizeLLE);
      formData.append("sizeLSL", editFormData.sizeLSL);
      formData.append("stock_balL", editFormData.stock_balL);

      formData.append("sizeXLCheckbox", editFormData.sizeXLCheckbox);
      formData.append("sizeXLCH", editFormData.sizeXLCH);
      formData.append("sizeXLSH", editFormData.sizeXLSH);
      formData.append("sizeXLLE", editFormData.sizeXLLE);
      formData.append("sizeXLSL", editFormData.sizeXLSL);
      formData.append("stock_balXL", editFormData.stock_balXL);

      formData.append("sizeXXLCheckbox", editFormData.sizeXXLCheckbox);
      formData.append("sizeXXLCH", editFormData.sizeXXLCH);
      formData.append("sizeXXLSH", editFormData.sizeXXLSH);
      formData.append("sizeXXLLE", editFormData.sizeXXLLE);
      formData.append("sizeXXLSL", editFormData.sizeXXLSL);
      formData.append("stock_balXXL", editFormData.stock_balXXL);

      // Images are immutable and cannot be changed
      // formData.append("image_main", editingProduct.image_main || editingProduct.image || "");
      // formData.append("image_back", editingProduct.image_back || "");
      // formData.append("image_side", editingProduct.image_side || "");

      console.log("Sending update request...");
      const response = await fetch(`${backend_url}/admin/updateproduct`, {
        method: "POST",
        headers: {
          "auth-token": localStorage.getItem("auth-token"),
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to update product");
      }

      const data = await response.json();
      console.log("Update response:", data);

      if (data.success) {
        alert("Product updated successfully");
        setEditingProduct(null);
        setEditImages({
          image_main: null,
          image_back: null,
          image_side: null,
        });
        await fetchInfo();
        console.log("Product list refreshed");
      } else {
        alert(data.message || "Failed to update product");
      }
    } catch (error) {
      console.error("Error updating product:", error);
      alert("Error updating product: " + error.message);
    }
  };

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "";
    if (imagePath.startsWith("/upload/")) {
      imagePath = imagePath.replace("/upload/", "/");
    }
    return `${backend_url}${imagePath}`;
  };

  const getMainImageUrl = (product) => {
    return getImageUrl(product.image_main || product.image);
  };

  return (
    <div className="listproduct">
      <h1>All Products List</h1>
      <div className="listproduct-format-main">
        <p>Products</p>
        <p>Title</p>
        <p>Old Price</p>
        <p>New Price</p>
        <p>Category</p>
        <p>Type</p>
        <p>Stock Bal</p>
        <p>Actions</p>
      </div>
      <div className="listproduct-allproducts">
        <hr />
        {allproducts.map((product, index) => (
          <div key={index}>
            {editingProduct?.id === product.id ? (
              <div className="listproduct-edit-form">
                <form onSubmit={handleEditSubmit}>
                  <div className="edit-form-fields">
                    <div className="edit-form-field">
                      <label>Product Name (Cannot be changed):</label>
                      <input
                        type="text"
                        name="name"
                        value={editFormData.name}
                        onChange={handleEditFormChange}
                        readOnly
                        disabled
                        style={{
                          backgroundColor: "#f0f0f0",
                          color: "#666",
                          cursor: "not-allowed",
                        }}
                      />
                    </div>
                    <div className="edit-form-field">
                      <label>Description:</label>
                      <input
                        type="text"
                        name="description"
                        value={editFormData.description}
                        onChange={handleEditFormChange}
                        required
                      />
                    </div>
                    <div className="edit-form-field">
                      <label>Old Price:</label>
                      <input
                        type="number"
                        name="old_price"
                        value={editFormData.old_price}
                        onChange={handleEditFormChange}
                        required
                      />
                    </div>
                    <div className="edit-form-field">
                      <label>New Price:</label>
                      <input
                        type="number"
                        name="new_price"
                        value={editFormData.new_price}
                        onChange={handleEditFormChange}
                        required
                      />
                    </div>
                    <div className="edit-form-field">
                      <label>Category:</label>
                      <select
                        name="category"
                        value={editFormData.category}
                        onChange={handleEditFormChange}
                        required
                      >
                        <option value="Men">Men</option>
                        <option value="Kids">Kids</option>
                        <option value="Accessories">Accessories</option>
                      </select>
                    </div>
                    {editFormData.category === "Accessories" && (
                      <>
                        <div className="edit-form-field">
                          <label>Product Type:</label>
                          <select
                            name="productType"
                            value={editFormData.productType}
                            onChange={handleEditFormChange}
                            required
                          >
                            <option value="">Select Product Type</option>
                            <option value="Jeans">Jeans</option>
                            <option value="Belt">Belt</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>
                        {editFormData.productType === "Jeans" && (
                          <>
                            <div className="edit-form-field">
                              <label>Waist (inches):</label>
                              <input
                                type="number"
                                name="waist"
                                value={editFormData.waist}
                                onChange={handleEditFormChange}
                                placeholder="Waist size"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Thighs (inches):</label>
                              <input
                                type="number"
                                name="thighs"
                                value={editFormData.thighs}
                                onChange={handleEditFormChange}
                                placeholder="Thigh size"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Length (inches):</label>
                              <input
                                type="number"
                                name="length"
                                value={editFormData.length}
                                onChange={handleEditFormChange}
                                placeholder="Length"
                              />
                            </div>
                          </>
                        )}
                        {editFormData.productType === "Belt" && (
                          <div className="edit-form-field">
                            <label>Length (inches):</label>
                            <input
                              type="number"
                              name="length"
                              value={editFormData.length}
                              onChange={handleEditFormChange}
                              placeholder="Belt length"
                            />
                          </div>
                        )}
                        {/* Stock fields for all accessory types */}
                        <div className="edit-form-field">
                          <label>Stock Balance:</label>
                          <input
                            type="number"
                            name="stock_bal"
                            value={editFormData.stock_bal}
                            onChange={handleEditFormChange}
                            placeholder="Enter stock quantity"
                            required
                          />
                        </div>
                      </>
                    )}
                    {(editFormData.category === "Men" ||
                      editFormData.category === "Kids") && (
                      <>
                        {/* Size parameters for Men and Kids categories */}
                        <div className="edit-form-field">
                          <h4>Size Parameters</h4>
                        </div>

                        {/* Size S */}
                        <div className="edit-form-field">
                          <label>
                            <input
                              type="checkbox"
                              name="sizeSCheckbox"
                              checked={editFormData.sizeSCheckbox}
                              onChange={handleEditFormChange}
                            />
                            Size S Available
                          </label>
                        </div>
                        {editFormData.sizeSCheckbox && (
                          <>
                            <div className="edit-form-field">
                              <label>Size S - Chest (inches):</label>
                              <input
                                type="number"
                                name="sizeSCH"
                                value={editFormData.sizeSCH}
                                onChange={handleEditFormChange}
                                placeholder="Chest size"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size S - Shoulder (inches):</label>
                              <input
                                type="number"
                                name="sizeSSH"
                                value={editFormData.sizeSSH}
                                onChange={handleEditFormChange}
                                placeholder="Shoulder size"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size S - Length (inches):</label>
                              <input
                                type="number"
                                name="sizeSLE"
                                value={editFormData.sizeSLE}
                                onChange={handleEditFormChange}
                                placeholder="Length"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size S - Sleeve (inches):</label>
                              <input
                                type="number"
                                name="sizeSSL"
                                value={editFormData.sizeSSL}
                                onChange={handleEditFormChange}
                                placeholder="Sleeve size"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size S - Stock Balance:</label>
                              <input
                                type="number"
                                name="stock_balS"
                                value={editFormData.stock_balS}
                                onChange={handleEditFormChange}
                                placeholder="Stock balance"
                              />
                            </div>
                          </>
                        )}

                        {/* Size M */}
                        <div className="edit-form-field">
                          <label>
                            <input
                              type="checkbox"
                              name="sizeMCheckbox"
                              checked={editFormData.sizeMCheckbox}
                              onChange={handleEditFormChange}
                            />
                            Size M Available
                          </label>
                        </div>
                        {editFormData.sizeMCheckbox && (
                          <>
                            <div className="edit-form-field">
                              <label>Size M - Chest (inches):</label>
                              <input
                                type="number"
                                name="sizeMCH"
                                value={editFormData.sizeMCH}
                                onChange={handleEditFormChange}
                                placeholder="Chest size"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size M - Shoulder (inches):</label>
                              <input
                                type="number"
                                name="sizeMSH"
                                value={editFormData.sizeMSH}
                                onChange={handleEditFormChange}
                                placeholder="Shoulder size"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size M - Length (inches):</label>
                              <input
                                type="number"
                                name="sizeMLE"
                                value={editFormData.sizeMLE}
                                onChange={handleEditFormChange}
                                placeholder="Length"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size M - Sleeve (inches):</label>
                              <input
                                type="number"
                                name="sizeMSL"
                                value={editFormData.sizeMSL}
                                onChange={handleEditFormChange}
                                placeholder="Sleeve size"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size M - Stock Balance:</label>
                              <input
                                type="number"
                                name="stock_balM"
                                value={editFormData.stock_balM}
                                onChange={handleEditFormChange}
                                placeholder="Stock balance"
                              />
                            </div>
                          </>
                        )}

                        {/* Size L */}
                        <div className="edit-form-field">
                          <label>
                            <input
                              type="checkbox"
                              name="sizeLCheckbox"
                              checked={editFormData.sizeLCheckbox}
                              onChange={handleEditFormChange}
                            />
                            Size L Available
                          </label>
                        </div>
                        {editFormData.sizeLCheckbox && (
                          <>
                            <div className="edit-form-field">
                              <label>Size L - Chest (inches):</label>
                              <input
                                type="number"
                                name="sizeLCH"
                                value={editFormData.sizeLCH}
                                onChange={handleEditFormChange}
                                placeholder="Chest size"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size L - Shoulder (inches):</label>
                              <input
                                type="number"
                                name="sizeLSH"
                                value={editFormData.sizeLSH}
                                onChange={handleEditFormChange}
                                placeholder="Shoulder size"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size L - Length (inches):</label>
                              <input
                                type="number"
                                name="sizeLLE"
                                value={editFormData.sizeLLE}
                                onChange={handleEditFormChange}
                                placeholder="Length"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size L - Sleeve (inches):</label>
                              <input
                                type="number"
                                name="sizeLSL"
                                value={editFormData.sizeLSL}
                                onChange={handleEditFormChange}
                                placeholder="Sleeve size"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size L - Stock Balance:</label>
                              <input
                                type="number"
                                name="stock_balL"
                                value={editFormData.stock_balL}
                                onChange={handleEditFormChange}
                                placeholder="Stock balance"
                              />
                            </div>
                          </>
                        )}

                        {/* Size XL */}
                        <div className="edit-form-field">
                          <label>
                            <input
                              type="checkbox"
                              name="sizeXLCheckbox"
                              checked={editFormData.sizeXLCheckbox}
                              onChange={handleEditFormChange}
                            />
                            Size XL Available
                          </label>
                        </div>
                        {editFormData.sizeXLCheckbox && (
                          <>
                            <div className="edit-form-field">
                              <label>Size XL - Chest (inches):</label>
                              <input
                                type="number"
                                name="sizeXLCH"
                                value={editFormData.sizeXLCH}
                                onChange={handleEditFormChange}
                                placeholder="Chest size"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size XL - Shoulder (inches):</label>
                              <input
                                type="number"
                                name="sizeXLSH"
                                value={editFormData.sizeXLSH}
                                onChange={handleEditFormChange}
                                placeholder="Shoulder size"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size XL - Length (inches):</label>
                              <input
                                type="number"
                                name="sizeXLLE"
                                value={editFormData.sizeXLLE}
                                onChange={handleEditFormChange}
                                placeholder="Length"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size XL - Sleeve (inches):</label>
                              <input
                                type="number"
                                name="sizeXLSL"
                                value={editFormData.sizeXLSL}
                                onChange={handleEditFormChange}
                                placeholder="Sleeve size"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size XL - Stock Balance:</label>
                          <input
                            type="number"
                                name="stock_balXL"
                                value={editFormData.stock_balXL}
                                onChange={handleEditFormChange}
                                placeholder="Stock balance"
                              />
                            </div>
                          </>
                        )}

                        {/* Size XXL */}
                        <div className="edit-form-field">
                          <label>
                            <input
                              type="checkbox"
                              name="sizeXXLCheckbox"
                              checked={editFormData.sizeXXLCheckbox}
                            onChange={handleEditFormChange}
                          />
                            Size XXL Available
                          </label>
                        </div>
                        {editFormData.sizeXXLCheckbox && (
                          <>
                            <div className="edit-form-field">
                              <label>Size XXL - Chest (inches):</label>
                              <input
                                type="number"
                                name="sizeXXLCH"
                                value={editFormData.sizeXXLCH}
                                onChange={handleEditFormChange}
                                placeholder="Chest size"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size XXL - Shoulder (inches):</label>
                              <input
                                type="number"
                                name="sizeXXLSH"
                                value={editFormData.sizeXXLSH}
                                onChange={handleEditFormChange}
                                placeholder="Shoulder size"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size XXL - Length (inches):</label>
                              <input
                                type="number"
                                name="sizeXXLLE"
                                value={editFormData.sizeXXLLE}
                                onChange={handleEditFormChange}
                                placeholder="Length"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size XXL - Sleeve (inches):</label>
                              <input
                                type="number"
                                name="sizeXXLSL"
                                value={editFormData.sizeXXLSL}
                                onChange={handleEditFormChange}
                                placeholder="Sleeve size"
                              />
                            </div>
                            <div className="edit-form-field">
                              <label>Size XXL - Stock Balance:</label>
                              <input
                                type="number"
                                name="stock_balXXL"
                                value={editFormData.stock_balXXL}
                                onChange={handleEditFormChange}
                                placeholder="Stock balance"
                              />
                            </div>
                          </>
                        )}
                      </>
                    )}
                    <div className="edit-form-field image-field">
                      <label>Main Image (Cannot be changed):</label>
                      <div className="edit-form-image">
                        <div
                          className="upload-area"
                          style={{ cursor: "not-allowed", opacity: 0.6 }}
                        >
                          <img src={getMainImageUrl(product)} alt="" />
                        </div>
                        <p>Images cannot be changed once uploaded</p>
                      </div>
                    </div>
                    <div className="edit-form-field image-field">
                      <label>Back Image (Cannot be changed):</label>
                      <div className="edit-form-image">
                        <div
                          className="upload-area"
                          style={{ cursor: "not-allowed", opacity: 0.6 }}
                        >
                          <img
                            src={getImageUrl(product.image_back) || upload_area}
                            alt=""
                          />
                        </div>
                        <p>Images cannot be changed once uploaded</p>
                      </div>
                    </div>
                    <div className="edit-form-field image-field">
                      <label>Side Image (Cannot be changed):</label>
                      <div className="edit-form-image">
                        <div
                          className="upload-area"
                          style={{ cursor: "not-allowed", opacity: 0.6 }}
                        >
                          <img
                            src={getImageUrl(product.image_side) || upload_area}
                            alt=""
                          />
                        </div>
                        <p>Images cannot be changed once uploaded</p>
                      </div>
                    </div>
                  </div>
                  <div className="edit-form-buttons">
                    <button type="submit">Save Changes</button>
                    <button
                      type="button"
                      onClick={() => setEditingProduct(null)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            ) : (
              <div className="listproduct-format-main listproduct-format">
                <img
                  className="listproduct-product-icon"
                  src={getMainImageUrl(product)}
                  alt=""
                />
                <p className="cartitems-product-title">{product.name}</p>
                <p>
                  {currency}
                  {product.old_price}
                </p>
                <p>
                  {currency}
                  {product.new_price}
                </p>
                <p>{product.category}</p>
                <p>{product.productType || "-"}</p>
                <p>
                  {product.stock_bal !== undefined
                    ? product.stock_bal
                    : Number(product.stock_qty || 0) -
                      Number(product.stock_left || 0)}
                </p>
                <div className="listproduct-actions">
                  <img
                    className="listproduct-action-icon"
                    onClick={() => handleEdit(product)}
                    src={edit_icon}
                    alt="Edit"
                  />
                  <img
                    className="listproduct-action-icon"
                    onClick={() => removeProduct(product.id)}
                    src={cross_icon}
                    alt="Remove"
                  />
                </div>
              </div>
            )}
            <hr />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListProduct;
